/**
 * V2 Textarea — themed to V2 tokens, faithful to `textarea.inp` in
 * design_reference/styles/app.css.
 */

import { forwardRef } from 'react';
import type { TextareaHTMLAttributes } from 'react';
import { cn } from '../../../lib/utils';

/** Props for the V2 Textarea (native textarea attributes). */
export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

/** V2 multiline text input. */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        'w-full px-[11px] py-[9px] rounded-[var(--r-md)] leading-[1.5] resize-y',
        'bg-[var(--bg-inset)] border border-[var(--bd)] text-[var(--tx-hi)] text-[13px]',
        'shadow-[inset_0_1px_1px_rgba(0,0,0,.15)] outline-none',
        'placeholder:text-[var(--tx-faint)]',
        'focus:border-[var(--accent-line)] focus:shadow-[0_0_0_3px_var(--accent-soft)]',
        'disabled:opacity-50 disabled:pointer-events-none',
        className,
      )}
      {...props}
    />
  ),
);
Textarea.displayName = 'Textarea';
